import { render, staticRenderFns } from "./Zeitkonto.vue?vue&type=template&id=873a1a14&scoped=true&"
import script from "./Zeitkonto.vue?vue&type=script&lang=js&"
export * from "./Zeitkonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873a1a14",
  null
  
)

export default component.exports